import { createTheme, toggleButtonClasses } from '@mui/material';
import shadows, { Shadows } from '@mui/material/styles/shadows';

export const muiGlobalTheme = createTheme({
  shape: {
    borderRadius: 12,
  },
  palette: {
    primary: {
      main: '#004998',
    },
    secondary: {
      main: '#1ABC9C',
      contrastText: '#ffffff',
    },
    background: {
      default: '#F5F5F5',
    },
    error: {
      main: '#F90014',
    },
    warning: {
      main: '#E67E22',
    },
  },
  typography: {
    fontFamily: 'Open Sans',
    fontSize:14,
    h3: {
      fontSize:16,
      fontWeight:'bold',
    },
    h4: {
      fontSize:14,
      fontWeight:'bold',
    },
  },
  shadows: shadows.map(() => 'none') as Shadows,
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: ({ theme, ownerState }) => ({
          color: theme.palette.grey[600],
          backgroundColor: theme.palette.background.paper,
          '.MuiInputBase-input, .MuiOutlinedInput-input': {
            fontSize: 14,
            fontWeight: '600',
          },
          '.MuiOutlinedInput-notchedOutline': {
            borderWidth: 2,
          },
          '.MuiOutlinedInput-input': {
            height: 'auto',
            padding: theme.spacing(1, 2),
          },
        }),
      },
    },
    MuiSelect :{
      styleOverrides: {
        standard:{
          ":root":{
            background:'red'
          }
        }
      }
    },
    MuiFormControlLabel:{
      styleOverrides:{
        label:{
          fontSize:14
        }
    }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: '600',
          textTransform: 'initial',
          '&,&:hover': {
            borderWidth:2,
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: { colorDefault: 'white' },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: ({ ownerState, theme }) => {
          ownerState.color = ownerState.color === 'standard' ? 'primary' : ownerState.color;
          const ownerStateColor = theme.palette[ownerState.color || 'primary'];
          return {
            minHeight: 39,
            textTransform: 'initial',
            color: ownerStateColor.main,
            background: ownerStateColor.contrastText,
            borderWidth: 2,
            borderColor: ownerStateColor.main,
            padding: '5px 15px',
            fontWeight: '600',
            fontSize: 14,
            '&:hover': {
              backgroundColor: ownerStateColor.light,
              color: ownerStateColor.contrastText,
            },
            [`&.${toggleButtonClasses.selected}`]: {
              color: ownerStateColor.contrastText,
              backgroundColor: ownerStateColor.main,
              '&:hover': {
                backgroundColor: ownerStateColor.dark,
              },
            },
          };
        },
      },
    },
    MuiDialogTitle:{
      styleOverrides: {        
        root: ({ theme }) => ({
          color: theme.palette.primary.dark,     
          borderBottom: `1px solid ${theme.palette.grey[500]}`,
          padding: `${theme.spacing(2)} 0 0`,
          margin: `0 ${theme.spacing(2)} ${theme.spacing(1)}`,
        }),
      },
    },
    MuiDialogContentText:{
      styleOverrides: {
        root: {
          color: 'currentColor',
        },
      },
    },
  },
});
